/**
 * The app bar's shape while the account loads: the workspace switcher, the
 * plan, and the person. The same skeleton the rest of the system draws,
 * because the bar is already a `.ds` scope.
 */
import { Skeleton } from '@/design-system/primitives'

export function HeaderSkeleton() {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 12 }} aria-hidden="true">
      <Skeleton width={160} height={36} />
      <Skeleton width={96} height={36} />
      <Skeleton width={36} height={36} />
    </div>
  )
}
